import SearchResultsTable from './SearchResultsTable.component';

export default SearchResultsTable;
